export default () => `var clickTag='\${CLICK_URL}';`;



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Render/components/HTMLTag/dv360.js